export default function unLoad() {
  this.dataSet("conf/load",false);
}
